// AWSCostDashboard.js - Wrapper dengan token dan onDataChange ke AI
import React, { useEffect, useRef } from 'react';
import { useDashboardData } from '../context/DashboardDataContext';
import { useActiveDashboard } from '../context/ActiveDashboardContext';
import AwsCostDashboard from '../dashboards/AwsCostDashboard';

export default function AWSCostDashboardPage() {
  const { publishData } = useDashboardData();
  const activeKey       = useActiveDashboard();
  const lastData        = useRef(null);
  const token           = localStorage.getItem('auth_token') || '';

  // Re-publish saat dashboard ini aktif kembali
  useEffect(() => {
    if (activeKey === 'aws_cost' && lastData.current) {
      publishData(lastData.current);
    }
  }, [activeKey]); // eslint-disable-line

  const handleDataChange = (data) => {
    if (!data) return;
    const payload = { type: 'aws_cost', ...data, updatedAt: new Date().toISOString() };
    lastData.current = payload;
    publishData(payload);
  };

  return (
    <AwsCostDashboard
      token={token}
      onDataChange={handleDataChange}
    />
  );
}
